import React, { useContext, useEffect, useState } from "react";
import excelToJson from "../utils/excelToJson";
import { Input } from "./ui/input";
import { Alert, Button, Group, Stack } from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import { AlertCircle } from "lucide-react";
import axios from 'axios'
import { AuthContext } from "../contexts/Auth/Auth.Context";
import { REACT_APP_UPLOADS } from "../constants";

const ExcelUploader: React.FC = () => {
    const { state } = useContext(AuthContext); 
  const [data, setData] = useState<any[]>([]); // State to store the JSON data
  const [error, setError] = useState<string | null>(null); // State to handle errors
  const [loading, setLoading] = useState(false); // State to handle loading state
  const [loading2, setLoading2] = useState(false); // State to handle loading state

  const { height } = useViewportSize();

  const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]; // Get the selected file
    if (file) {
        try {
         setLoading(true); // Set loading state to true
          const jsonData = await excelToJson(file); // Convert Excel to JSON
          console.log(jsonData);
          setData(jsonData); // Update the state with the JSON data
          setError(null); // Clear any previous errors
          setLoading(false); // Set loading state to false
        } catch (err) {
          setError("Failed to process the Excel file. Please try again."); // Handle errors
          console.error("Error reading Excel file:", err);
        }
      }
  };

  const submitData = () => {
    setLoading2(true); // Set loading state to true
    // send to server

    axios.post(`${REACT_APP_UPLOADS}/api/v1/seizure-cases/upload`,data).then(function(res){
        if(res.status === 200){
            setLoading2(false);
            window.location.reload();
        }
    }).catch(function(error){
        setError(error?.message);
        setLoading2(false);
    })
  }

  return (
        <Stack justify="between" h={height * 0.8} spacing="xs">
        <Alert title="Cost Implications" icon={<AlertCircle />} color="red" mb="md">
            Uploading datasets without coordinates will result in a cost of $1-$2 per 1000 records. This cost is related to the geocoding process, which converts addresses into geographic coordinates. Please ensure that your dataset contains valid coordinates to avoid unnecessary charges.
        </Alert>
        <div className="space-y-4">
          <Input
            type="file"
            accept=".xlsx, .xls"
            onChange={handleFileUpload}
            className="block w-full"
            
          />
            {loading && <p>Please wait until we&apos;ve processed all the data...</p>}
        </div>

        <Group>
            <Button variant="default" onClick={() => {setData([]); setError(null); window.location.reload()}} disabled={loading} >
                Clear
            </Button>
        <Button onClick={() => {submitData()}} loading={loading || loading2} disabled={loading || data.length === 0} >
            {loading && !loading2 ? "Processing Dataset" : !loading && loading2 ? "Uploading Dataset" : "Upload Dataset"}
          </Button>
        </Group>
        </Stack>
  );
};

export default ExcelUploader;